import React from "react";
import { Home, FileText, LogOut } from "lucide-react";

import { User } from "../../interfaces/user.interface";
import { OrderItem } from "../../interfaces/order.interface";
import { OrderList } from "../OrderList";
import {
  ChatContainer,
  Header,
  HeaderContent,
  Brand,
  BrandIcon,
  BrandLogo,
  BrandText,
  NavLinks,
  NavLink,
  UserSection,
  UserAvatar,
  UserInfo,
  UserName,
  UserEmail,
  LogoutButton,
  MainContent,
} from "./style";

interface OrdersPageProps {
  user: User;
  onLogout: () => void;
  items: OrderItem[];
}

export const OrdersPage = ({ user, onLogout, items }: OrdersPageProps) => {
  return (
    <ChatContainer>
      <Header>
        <HeaderContent>
          <Brand>
            <BrandIcon>
              <BrandLogo src="/logo.png" />
            </BrandIcon>
            <BrandText>Infinity Copilot</BrandText>
          </Brand>

          <NavLinks>
            <NavLink href="/">
              <Home size={18} />
              Home
            </NavLink>
            <NavLink href="https://docs.infinity-copilot.com/" target="_blank">
              <FileText size={18} />
              Documentation
            </NavLink>
          </NavLinks>

          <UserSection>
            <UserAvatar src={user.picture} alt={user.name} />
            <UserInfo>
              <UserName>{user.name}</UserName>
              <UserEmail>{user.email}</UserEmail>
            </UserInfo>
            <LogoutButton onClick={onLogout} title="Logout">
              <LogOut size={18} />
            </LogoutButton>
          </UserSection>
        </HeaderContent>
      </Header>
      <MainContent>
        <OrderList items={items} />
      </MainContent>
    </ChatContainer>
  );
};
